import { useState, useRef } from 'react';

export default function FleetProfileImport({ onImport }: { onImport: (profile: number[]) => void }) {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);
  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(null); setSuccess(false);
    const file = e.target.files?.[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const text = ev.target?.result as string;
        const lines = text.trim().split('\n').map(l => l.trim()).filter(l => l.length > 0);
        const firstLine = lines[0].toLowerCase();
        const hasHeader = firstLine.includes('hour') || firstLine.includes('uur');
        const dataLines = hasHeader ? lines.slice(1) : lines;
        if (dataLines.length !== 24) { setError(`Verwacht 24 waarden, ${dataLines.length} gevonden.`); return; }
        const profile: number[] = [];
        for (let i = 0; i < 24; i++) {
          const parts = dataLines[i].split(/[;,\t]/);
          const val = parseFloat(parts[parts.length > 1 ? 1 : 0]);
          if (isNaN(val) || val < 0) { setError(`Ongeldige waarde op regel ${i + 1}`); return; }
          profile.push(val);
        }
        onImport(profile); setSuccess(true);
      } catch { setError('Fout bij het lezen van het bestand.'); }
    };
    reader.readAsText(file);
  };
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">📂 Vlootprofiel Importeren</div>
      <div className="text-[10px] text-[#8899AA] mb-3">Upload een CSV met 24 uurwaarden.</div>
      <input ref={fileRef} type="file" accept=".csv,.txt" onChange={handleFile} className="hidden" />
      <button onClick={() => fileRef.current?.click()} className="px-4 py-1.5 text-[11px] font-bold rounded-lg border border-[#D9E2EC] bg-[#F5F8FB] text-[#0B1F4A] hover:bg-[#EEF2F7] cursor-pointer">📂 Kies CSV-bestand</button>
      {error && <div className="mt-2 text-[10px] text-[#991B1B] bg-[#FEF2F2] rounded-lg px-3 py-1.5 border border-[#FECACA]">❌ {error}</div>}
      {success && <div className="mt-2 text-[10px] text-[#166534] bg-[#F0FDF4] rounded-lg px-3 py-1.5 border border-[#BBF7D0]">✅ Geïmporteerd!</div>}
    </div>
  );
}
